/**
 * CP org owner always gets these modules without a subscription feature assignment.
 * Keep feature codes aligned with `user` in `cp-portal-modules.config.ts` /
 * user-ms `CP_MODULE_PRIMARY_ENTITLEMENTS.user`.
 */
export const CP_OWNER_DEFAULT_MODULE_SLUGS = ['user'] as const;

export type CpOwnerDefaultModuleSlug =
  (typeof CP_OWNER_DEFAULT_MODULE_SLUGS)[number];

export const CP_OWNER_DEFAULT_ENTITLEMENT_FEATURES = [
  'FEAT_SYS_INTERNAL_USERS',
  'FEAT_SYS_ROLES',
  'FEAT_SYS_DEPARTMENTS',
] as const;

export function isCpOwnerDefaultModuleSlug(
  slug: string | null | undefined,
): slug is CpOwnerDefaultModuleSlug {
  const value = slug?.trim();
  if (!value) {
    return false;
  }
  return (CP_OWNER_DEFAULT_MODULE_SLUGS as readonly string[]).includes(value);
}
